import React from 'react';
import { getFieldTypeMeta } from '../../../features/builder/fieldRegistry';
import GridTable from '../../../components/RadioGridView/GridTable';
import DataTable from '../../TableView/DataTable';
import GridQuestionView from '../../../components/GridQuestionView/GridQuestionView';
import { QuestionType } from '../../../core/constants/common';
import { useBuilderEditor } from '../../../features/builder/BuilderEditorContext';

const FieldPreview = ({ field }) => {
  const meta = getFieldTypeMeta(field.type);
  const Icon = meta.icon;
  const { allFormFields } = useBuilderEditor();

  const renderInput = () => {
    switch (field.type) {
      case QuestionType.SINGLE_TEXTBOX:
        return <input className="builder-field-preview__input" disabled placeholder="Short answer text" />;
      case QuestionType.TEXT_BOX:
        return <textarea className="builder-field-preview__textarea" disabled placeholder="Long answer text" rows={3} />;
      case QuestionType.NUMERIC_VALUE:
        return <input className="builder-field-preview__input" type="number" disabled placeholder="0" />;
      case QuestionType.DROP_DOWN:
      case QuestionType.MULTI_SELECT_DROP_DOWN:
        return (
          <select className="builder-field-preview__input" disabled>
            <option>{field.options?.[0]?.name || 'Select an option'}</option>
          </select>
        );
      case QuestionType.RADIO:
      case QuestionType.MULTIPLE_CHOICE:
        return (
          <div className="builder-field-preview__options">
            {(field.options || []).slice(0, field.maxOptions).map((opt, i) => (
              <label key={i} className="builder-field-preview__option">
                <input type={field.type === QuestionType.MULTIPLE_CHOICE ? 'checkbox' : 'radio'} disabled />
                <span>{opt.name || (opt.showOthers ? 'Other' : `Option ${i + 1}`)}</span>
              </label>
            ))}
          </div>
        );
      case QuestionType.RADIO_GRID:
        return field.gridConfig ? (
          <GridTable type="BUILD" content={field} />
        ) : (
          <div className="builder-field-preview__file">Radio grid (no columns configured)</div>
        );
      case QuestionType.TABLE:
        return field.tableConfig?.columns?.length > 0 ? (
          <DataTable type="BUILD" content={field} />
        ) : (
          <div className="builder-field-preview__file">Table (no columns configured)</div>
        );
      case QuestionType.GRID:
        return (
          <GridQuestionView
            content={field}
            answerContext={{
              readOnly: false,
              getDisplayValue: () => '',
              getChangeHandler: () => undefined,
              renderExtra: (linkedFieldId) => {
                const linkedField = allFormFields?.find((f) => f.id === linkedFieldId);
                if (linkedField?.type !== QuestionType.NUMERIC_VALUE || !linkedField.uomRequired) return null;
                const relevantUoms = linkedField.relevantUoms;
                return (
                  <select className="builder-field-preview__input" disabled>
                    {relevantUoms?.length > 0
                      ? [...relevantUoms].sort((a, b) => a.localeCompare(b)).map((u) => (
                        <option key={u}>{u}</option>
                      ))
                      : <option>Unit</option>}
                  </select>
                );
              },
            }}
          />
        );
      case QuestionType.DATE_TIME_BOX:
        return <input className="builder-field-preview__input" type="date" disabled />;
      case QuestionType.DATE_RANGE:
        return (
          <div className="builder-field-preview__row">
            <input className="builder-field-preview__input" type="date" disabled />
            <span>to</span>
            <input className="builder-field-preview__input" type="date" disabled />
          </div>
        );
      case QuestionType.FILE_UPLOAD:
        return <div className="builder-field-preview__file">Choose file to upload</div>;
      case QuestionType.RATING:
        return <div className="builder-field-preview__rating">★ ★ ★ ★ ☆</div>;
      default:
        return <input className="builder-field-preview__input" disabled placeholder="Answer" />;
    }
  };

  return (
    <div className="builder-field-preview">
      {/* <div className="builder-field-preview__type">
        <Icon aria-hidden="true" />
        <span>{meta.label}</span>
      </div> */}
      {renderInput()}
    </div>
  );
};

export default FieldPreview;
